exports.linkResolver = (doc) => {
  if (doc.uid !== 'index' && doc.type === 'page') return `/${doc.uid}/`
  if (doc.type === 'event') return `/events/${doc.uid}/`
  if (doc.type === 'venue') return `/venues/${doc.uid}/`
  if (doc.type === 'news_article') return `/news/${doc.uid}/`
  return `/`
}
